import { Avatar, Button, Card, CardContent, Typography } from "@common-ui/ui";
import { AddCircle } from "@mui/icons-material";
import UsersDetailPanel from "./UsersDetailPanel";

import { getAvatarInitials } from "../../utils";
import checkTableValue from "../../utils/checkTableValue";

const UsersTableView = (props) => {
  const membersCount = (props?.users) ? props?.users?.length : 0;
  const columns = [
    {
      width: 100,
      field: "avatar",
      headerName: "",
      align: "center",
      sortable: false,
      renderCell: (params) => {
        const FN = (params.row.first_name || params.row.last_name) ? params.row.first_name + " " + params.row.last_name : params.row.username;
        return <Avatar alt={FN} src={getAvatarInitials(FN)} />
      }
    },
    {
      field: "first_name",
      flex: 1,
      headerName: "First Name",
      renderCell: (params) => checkTableValue(params?.value)
    },
    {
      field: "last_name",
      flex: 1,
      headerName: "Last Name",
      renderCell: (params) => checkTableValue(params?.value)
    },
    {
      field: "org_role",
      flex: 1,
      headerName: "Role",
      renderCell: (params) => checkTableValue(params?.value)
    },
    {
      field: "title",
      flex: 1,
      headerName: "Title",
      renderCell: (params) => checkTableValue(params?.value)
    },
    {
      field: "email",
      flex: 1,
      headerName: "Email",
      renderCell: (params) => checkTableValue(params?.value)
    },
    {
      field: "phone_number",
      flex: 1,
      headerName: "Phone",
      renderCell: (params) => checkTableValue(params?.value)
    }
  ];
  return (
    <>
      <Card sx={{ width: "100%" }}>
        {props?.isShowTableHeader && (
          <CardContent sx={{
            display: "flex",
            justifyContent: "space-between",
            padding: ".5rem 1rem",
            alignItems: "center"
          }}>
            <Typography variant="h5" component="div">
              Members: ({membersCount})
            </Typography>
            <Button
              size="medium"
              type="button"
              variant="text"
              startIcon={<AddCircle />}
              sx={{ ml: 2, color: (theme) => theme.palette.grey[700] }}
            >
              Add Member
            </Button>
          </CardContent>
        )}
        <UsersDetailPanel {...props} columns={columns} rowSize={props?.rowSize} />
      </Card>
    </>
  );
};

UsersTableView.defaultProps = {
  isShowTableHeader: true
}

export default UsersTableView;